module.exports = __webpack_public_path__ + "img/m.0a28424a.png";